import type { BureauRelationshipResponse } from '@api/swagger/definitions/backoffice'
import type { BureauConfig } from '@mynt/backoffice-api-spec/bureau'
import type { BureauFeatures, BureauParent } from './api'

export const mapBureauRelationshipResponseToBureauParent = (response: BureauRelationshipResponse): BureauParent => ({
  bureauId: response.bureauId!,
  bureauName: response.bureauName!,
  bureauClientId: response.bureauClientId!,
  bureauClientName: response.bureauClientName!,
})

export const mapBureauConfigToBureauFeatures = (config: BureauConfig): BureauFeatures => ({
  agencyPortal: config.agencyPortalEnabled,
  agencyTeams: config.agencyPortalTeamsEnabled,
})

export const mapBureauFeaturesToBureauConfig = (features: BureauFeatures): BureauConfig => ({
  agencyPortalEnabled: features.agencyPortal,
  agencyPortalTeamsEnabled: features.agencyTeams,
})
